import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'logComments',
    label: 'Comments',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
